export function getHostname() {
  const hostname = window.location.hostname.replace(/^(https?:\/\/)?(www\.)?/, "").replace(/[.-]/g, "_");
  return hostname.includes("localhost") || hostname.includes("speedcast") ? "default" : hostname;
}
